'use strict';

require('./widget.component.css');

export default class WidgetComponent {
  constructor() {
    this.restrict = 'EA'
    this.scope = {
      widgetTitle: '=',
      subTitle: '=',
      icon: '=',
      count: '=',
      subCount: '=',
      state: '=',
      callback: '=',
      callbackMeta: '=',
        linkActive: '='
    }
    this.template = require('./widget.component.html');
    this.controller = WidgetComponentController;
    this.controllerAs = 'ctrl';
    this.bindToController = true;
  }
}

class WidgetComponentController {

  constructor($rootScope, $scope, $log, $uibModal, helperService, dataService) {
    this.helperService = helperService;
    this.$scope = $scope;
    this.$rootScope = $rootScope
    this.$log = $log;
    this.$uibModal = $uibModal;
    this.dataService = dataService;
    this.state = 'LOADING';
  }

  triggerCallback() {
    if (!this.linkActive) return;
    this.$log.info('Triggering callback for widget...');
    this.callback(this.callbackMeta);
  }
}
